import BodyweightCategoryForm from '../../components/BodyweightCategoryForm';
import TableEditor from '../../components/TableEditor';
import { Label, Table } from '../../components';
import { createOrmActions, editorPropTypes } from '../../components/common';

import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

const BodyweightCategoriesEditorHeader = ({ children }) => (
  <Table.Row>
    <Table.HeaderCell>Bundle</Table.HeaderCell>
    <Table.HeaderCell>Gender</Table.HeaderCell>
    <Table.HeaderCell>Title</Table.HeaderCell>
    <Table.HeaderCell>Abbreviation</Table.HeaderCell>
    <Table.HeaderCell>Bodyweight minimum</Table.HeaderCell>
    <Table.HeaderCell>Bodyweight maximum</Table.HeaderCell>
    {children}
  </Table.Row>
);

const BodyweightCategoriesEditorRow = ({ row, children }) => (
  <Table.Row>
    <Table.Cell>{row.bundle}</Table.Cell>
    <Table.Cell>{row.gender && <Label>{row.gender.title}</Label>}</Table.Cell>
    <Table.Cell>{row.title}</Table.Cell>
    <Table.Cell>{row.abbreviation}</Table.Cell>
    <Table.Cell>{row.bodyweightMinimum}</Table.Cell>
    <Table.Cell>{row.bodyweightMaximum}</Table.Cell>
    {children}
  </Table.Row>
);

const BodyweightCategoriesEditor = ({
  id,
  bodyweightCategories,
  meta,
  actions,
}) => {
  const defaultValues = {
    bundle: '',
    gender: '',
    title: '',
    abbreviation: '',
    bodyweightMinimum: '',
    bodyweightMaximum: '',
  };

  const rows = bodyweightCategories.map(bodyweightCategory => ({
    ...bodyweightCategory,
    key: bodyweightCategory.id,
    description: `bodyweight category ${bodyweightCategory.title}`,
    currentValues: {
      ...pick(bodyweightCategory, [
        'bundle',
        'title',
        'abbreviation',
        'bodyweightMinimum',
        'bodyweightMaximum',
      ]),
      gender: bodyweightCategory.gender.primaryKey,
    },
  }));

  return (
    <TableEditor
      id={id}
      Form={BodyweightCategoryForm}
      Header={BodyweightCategoriesEditorHeader}
      Row={BodyweightCategoriesEditorRow}
      rows={rows}
      defaultValues={defaultValues}
      actions={createOrmActions(actions, rows)}
      meta={meta}
    />
  );
};

BodyweightCategoriesEditor.propTypes = {
  ...editorPropTypes,
  bodyweightCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BodyweightCategoriesEditor;



// WEBPACK FOOTER //
// ./src/pages/Setup/BodyweightCategoriesEditor.js